import { Controller, useFormContext } from 'react-hook-form'

import { FF2, Select } from 'ui/components'
import { NAICSCodes } from '~bank-bsa-reporting/constants/NAICSCode'
import { SarEdit } from '~bank-bsa-reporting/types'

export const NAICSCode = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.naicsCode`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="10a. NAICS Code"
          input={(props) => <Select {...props} data={NAICSCodes} emptyOption={{ label: 'Not selected', value: '' }} />}
        />
      )}
    />
  )
}
